import * as React from 'react';

/**
 * Hook that calls a function on an interval, pass null to delay to disable
 */
const useInterval = (callback: () => void, delay: number | null) => {
    const savedCallback = React.useRef<typeof callback>(null);

    // Remember the latest callback
    React.useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // Set up the interval
    React.useEffect(() => {
        if (delay === null) {
            return;
        }

        const id = setInterval(() => {
            savedCallback.current();
        }, delay);

        return () => {
            clearInterval(id);
        };
    }, [delay]);
};

export default useInterval;
